import { lazy } from "react";

const PaymentReports = lazy(() =>
  import("../Report").then((m) => ({ default: m.PaymentReports }))
);
const TaxReports = lazy(() =>
  import("../Report").then((m) => ({ default: m.TaxReports }))
);
const UserReports = lazy(() =>
  import("../Report").then((m) => ({ default: m.UserReports }))
);
const RegClosuresReports = lazy(() =>
  import("../Report/RegisterClosures/RegClosuresReports")
);
const ViewRegister = lazy(() =>
  import("../Report/RegisterClosures/ViewRegister/ViewRegister")
);
const CreditCustomer = lazy(() =>
  import("../Report/CreditCustomer/CreditCustomer")
);
const ProductPerform = lazy(() =>
  import("../Report/ProductPerform/ProductPerform")
);
// RetailReport intentionally not imported — see the note on /retail_dashboard below.
const StockMovement = lazy(() =>
  import("../Inventory/Stock/StockMovement/StockMovement")
);
const ItemWiseSales = lazy(() =>
  import("../Report/ItemWiseSales/ItemWiseSales")
);
const CustomerWisePL = lazy(() =>
  import("../Report/CustomerWisePL/CustomerWisePL")
);
const ExpenseReport = lazy(() =>
  import("../Report/ExpenseReport/ExpenseReport")
);
const ProfitByInvoice = lazy(() =>
  import("../Report/ProfitByInvoice/ProfitByInvoice")
);
const SalesSummary = lazy(() =>
  import("../Report/SalesSummary/SalesSummary")
);
const BusinessActivity = lazy(() =>
  import("../Report/BusinessActivity/BusinessActivity")
);
const StockReport = lazy(() =>
  import("../Report/StockReport/StockReport")
);
const LogReport = lazy(() =>
  import("../Report/LogReport/LogReport")
);
const InventoryAdjustmentReport = lazy(() =>
  import("../Report/InventoryAdjustmentReport/InventoryAdjustmentReport")
);

export const reportRoutes = (access, settings) => {
  if (!settings?.fiscalYearId || !access.reportAccess) return [];

  return [
    // /sales_reports retired 2026-07-28 — see menuConfig.jsx. The route is gone, so
    // the URL 404s rather than rendering COGS/Gross Profit/Margin to anyone holding
    // bare reportAccess.
    // Every route below carries an `enabled:` gate. SiteRoute renders any route
    // WITHOUT that key to anyone holding bare reportAccess, so an omission here is
    // not a smaller permission — it is no permission at all. Seven routes were in
    // that state until 2026-08-13, Sales Summary (the full per-invoice sales
    // ledger) among them.
    { path: "/payment_reports", element: PaymentReports, title: "paymentReports", enabled: access.report?.paymentReport },
    { path: "/register_closures", element: RegClosuresReports, title: "registerClosures", enabled: access.report?.registerClosure },
    { path: "/view_register/:id", element: ViewRegister, title: "viewRegister", enabled: access.report?.registerClosure },
    { path: "/tax_reports", element: TaxReports, title: "taxReports", enabled: access.report?.taxReport },
    { path: "/user_reports", element: UserReports, title: "userReports", enabled: access.report?.userReport },
    { path: "/credit_customer_report", element: CreditCustomer, title: "creditCustomerReport", enabled: access.report?.creditCustomer },
    { path: "/stock_movements_report", element: StockMovement, title: "stockMovements", enabled: access.report?.productMovement },
    { path: "/product_perform_report", element: ProductPerform, title: "productPerformance", enabled: access.report?.productMovement },
    // /retail_dashboard removed 2026-08-13 — it rendered hardcoded demo numbers,
    // had no menu link and no flag, so it was reachable by URL alone by anyone
    // with bare reportAccess. The component stays on disk.
    { path: "/item_wise_sales", element: ItemWiseSales, title: "itemWiseSales", enabled: access.report?.itemWiseSales },
    { path: "/customer_wise_pl", element: CustomerWisePL, title: "customerWisePL", enabled: access.report?.customerWiseProfitLoss },
    { path: "/expense_report", element: ExpenseReport, title: "expenseReport", enabled: access.report?.expenseReport },
    { path: "/profit_by_invoice", element: ProfitByInvoice, title: "profitByInvoice", enabled: access.report?.profitByInvoice },
    { path: "/sales_summary", element: SalesSummary, title: "salesSummary", enabled: access.report?.salesSummary },
    { path: "/business_activity", element: BusinessActivity, title: "businessActivity", enabled: access.report?.businessActivity },
    { path: "/stock_report", element: StockReport, title: "stockReport", enabled: access.report?.stockReport },
    { path: "/log_report", element: LogReport, title: "logReport", enabled: access.report?.logReport },
    { path: "/inventory_adjustment_report", element: InventoryAdjustmentReport, title: "inventoryAdjustmentReport", enabled: access.report?.inventoryAdjustmentReport },
  ];
};
